import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'
import SearchInput, {createFilter} from 'react-search-input'
import Modal from './Modal'

export default class extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { list: [], itemId: null, preloader: true, searchTerm: "" }
    this._bind('delete', 'getData', 'searchUpdated', 'closeConfirm')
    this.KEYS_TO_FILTERS = ['alias', 'title', 'description', 'slug', 'name', 'head', 'short', 'category']
  }

  getData() {
    let url = this.props.data.table === "user" ? this.props.API+"/api/admin/user/list/" : this.props.API+"/api/admin/data/list/"+this.props.data.table
    let params = { "start" : 0, "stop" : 999 }
    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        body: JSON.stringify(params)
      })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      //console.log(result)
      let res = result.data.result
      if (res === null) {
        res = []
      }
      this.setState({ list: res, preloader: false })
    }, (error) => {
      console.log(error)
    })
  }

  componentDidMount() {
    this.getData()
  }

  delete(id) {
    this.setState({ preloader: true })
    let params = { "id": id }
    let url = this.props.data.table === "user" ? this.props.API+"/api/admin/user/delete/" : this.props.API+"/api/admin/data/delete/"+this.props.data.table
    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
      },
      body: JSON.stringify(params)
    })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      //console.log(result)
      this.setState({ confirm: false, itemId: null })
      this.getData()
      if (result.error) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : result.error}}), true);
      } else {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "green", 'content' : "Pomyślnie usunięto."}}), true);
      }
    }, (error) => {
      console.log(error)
      window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : "Coś poszło nie tak."}}), true);
      this.setState({ preloader: false })
    })
  }

  searchUpdated(term) {
    this.setState({searchTerm: term})
  }

  closeConfirm() {
    this.setState({ confirm: false, itemId: null })
  }

  render () {
    let list = null

    let filteredList = this.state.list.filter(createFilter(this.state.searchTerm, this.KEYS_TO_FILTERS))

    const Confirm = (
      <div className="confirm">
        <h4>Czy jesteś pewny?</h4>
        <div className="btn-holder">
          <a className="btn" onClick={ this.closeConfirm }><span>Nie</span></a>
          <a className="btn" onClick={ this.delete.bind(null, this.state.itemId) }><span>Tak</span></a>
        </div>
      </div>
    )

    if (filteredList.length > 0) {
      list = filteredList.map((item, i) => {
        return (
          <li key={ i }>
            { item.image ? <div className="thumb">
              <img src={ item.image } alt=""/>
            </div> : null }
            <NavLink to={ this.props.data.route + "/" + item.id } style={{ textDecoration: "none" }}><h4 className={ item.image ? "withimg" : "" }>Nazwa: { item.alias ? item.alias : item.title ? item.title : item.name ? item.name : item.login }</h4></NavLink>
            <div className="controls">
              { this.props.user.role === "Administrator" || this.props.user.role === "Moderator" ? <div onClick={ () => { this.setState({ confirm: true, itemId: item.id }) } }><img src="/assets/img/icons/delete.png" alt=""/><span>{ this.props.data.delete }</span></div> : null }
              { this.props.user.role === "Administrator" || this.props.user.role === "Moderator" ? <div><NavLink to={ this.props.data.route + "/" + item.id }><img src="/assets/img/icons/edit.png" alt=""/><span>{ this.props.data.edit }</span></NavLink></div> : <div><NavLink to={ this.props.data.route + "/" + item.id }><img src="/assets/img/icons/edit.png" alt=""/><span>Podgląd</span></NavLink></div> }
            </div>
          </li>
        )
      })
    }

    return (
      <section className="list">
        <div className="container">
    			<h1>{ this.props.data.name }</h1>
          { this.props.user.role === "Administrator" || this.props.user.role === "Moderator" ? <NavLink to={ this.props.data.new } className="btn"><span>{ this.props.data.add }</span></NavLink> : null }
          <SearchInput className="search-input" onChange={this.searchUpdated} placeholder="Wyszukaj"/>
          <ul className="list-items">
            { filteredList.length > 0 ? list : <h5>Brak wyników!</h5> }
            { this.state.preloader ? <div className="preloader"><span></span></div> : null }
          </ul>
	  	  </div>
        <Modal open={ this.state.confirm } hidePopup={ this.closeConfirm }>{ Confirm }</Modal>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/ListPage.js